<template>
  <div>
    <span v-if="btns&&btns.length===0">-</span>
    <v-menu
      v-else
      offset-y
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          text
          :color="other.b_color || 'primary'"
          v-bind="attrs"
          v-on="on"
        >
          {{ other.b_text }}
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(btn,index) in btns"
          :key="index"
          link
        >
          <v-list-item-content>
            <v-list-item-title>
              <v-btn
                text
                @click="click(btn)"
              >
                {{ btn.text }}
              </v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
  export default {
    props: {
      btns: {
        type: Array,
        default:() => [] 
      },
      other: {
        type: Object,
        default: () => ({})
      },
      target: {
        type: Object,
        default: () => ({}) 
      }
    },
    methods: {
      click(btn) {
        this.other.callBack && this.other.callBack(btn, this.target)
      }
    }
  }
</script>